import { create } from "zustand";
import {
  ACTIVITY_MODE_STORAGE_KEY,
  ACTIVITY_MODE_WALK,
  normalizeActivityMode,
} from "../utils/activityMode.js";

const readInitialActivityMode = () => {
  if (typeof window === "undefined") return ACTIVITY_MODE_WALK;
  try {
    return normalizeActivityMode(
      window.localStorage.getItem(ACTIVITY_MODE_STORAGE_KEY),
      ACTIVITY_MODE_WALK
    );
  } catch {
    return ACTIVITY_MODE_WALK;
  }
};

export const useActivityModeStore = create((set) => ({
  activityMode: readInitialActivityMode(),
  setActivityMode: (mode) => {
    const next = normalizeActivityMode(mode, ACTIVITY_MODE_WALK);
    try {
      window.localStorage.setItem(ACTIVITY_MODE_STORAGE_KEY, next);
    } catch {}
    set({ activityMode: next });
    try {
      window.dispatchEvent(
        new CustomEvent("trekkin:activity-mode-changed", {
          detail: { mode: next },
        })
      );
    } catch {}
  },
}));
